import {debounce} from "../../debounce/debounce";
import "jquery-visible";
import scrollOnClick from "../../scrollOnClick";
import _ from "lodash";

export const STRICT_HEIGHT_TEXT = "Hauteur stricte";
export const BODY_FONT_HEIGHT_TEXT = "Corps de police";

// Voir également coté PHP
const DEFAULT_TEXT = "Votre texte";

// autorise l'utilisation de plusieurs "rouleaux" à partir de X lignes
const MULTIROLL_THRESHOLD_LINES = 5;

const DEBOUNCE_DURATION = 1500;

debounce();

export default class Letter {
    constructor() {
        this.currentRequest = null;
        this.notChangeImage = false;

        this.previewTimeout = null;
        this.stringTimeout = null;

        this.valuesArraySpacing = Letter.getDefaultValuesArraySpacing();

        this.globalMaxHeight = 58;
        this.globalMinHeight = 2.5;
        this.globalMinWidth = 0;
        this.globalMaxWidth = 0;

        this.colorHtml = '';
        this.bgColorHtml = 'none';

        this.string = $('#string');

        this.desiredWidth = $('#desired_width');
        this.desiredWidthResume = $('.desired_width');
        this.desiredHeight = $('#desired_height');
        this.quantity = $('.quantity-field');
        this.proportion = $('#proportion');

        this.leftClick = $(".left-click");
        this.rightClick = $(".right-click");
        this.upClick = $(".up-click");
        this.downClick = $(".down-click");

        this.colorId = $('#color_id');
        this.colorBgId = $('#color_bg_id');
        this.fontId = $('#font_id');
        this.sizeId = $('#size_id');
        this.containerPreview = $('#container-preview');
        this.moduleWindow = $('.wz-module-window').first();

        this.spacing = $('#spacing');
        this.mirror = $('.mirror');
        this.stencil = $('#stencil');
        this.stencil_color = $('#stencil_color');
        this.align = $('#align');
        this.alignItems = $('.js-align');
        this.strictHeight = $('#strict_height');

        this.loading = $('.loadingDiv');
        this.sizeTimer = null;

        this.nomade = $('#nomade').length > 0;
        // note Julien : attention, il semble que cette ligne ne fonctionne
        // pas comme prévu, #letter est présent lors du premier chargement
        // de la page, mais pas les suivants (cache race condition ?)
        this.letter = $('#letter').length > 0;

        this.editMode = $('#edit_mode').val();

        this.strictHeightTextSelector = $('.js-type-height-text');
    }

    /**
     * Legacy method
     *
     * @param {boolean} fromHeight
     */
    displayPreview(fromHeight) {
        if (this.previewTimeout) {
            clearTimeout(this.previewTimeout);
        }
        console.log(this.strictHeight.get(0))
        let values = {
            string: this.string.val(),
            quantity: this.quantity.val(),
            size_id: this.sizeId.val(),
            font_id: this.fontId.val(),
            color_id: this.colorId.val(),
            color_bg_id: this.colorBgId.val(),
            desired_width: this.desiredWidth.val(),
            desired_height: this.desiredHeight.val(),
            spacing: this.spacing.val(),
            mirror: this.mirror.find(':checked').val(),
            stencil: this.stencil.val(),
            stencil_color: this.stencil_color.val(),
            proportion: this.proportion.is(':checked') ? 1 : 0,
            from_height: fromHeight ? 1 : 0,
            align: this.align.val(),
            strict_height: this.strictHeight.is(':checked') ? 0 : 1,
        };

        this.previewTimeout = setTimeout(this.displayPreview_internal.bind(this, values), 100);
    }

    /**
     * Legacy method
     *
     * @param {object} data
     */
    displayPreview_internal(data) {
        let self = this;


        if (this.fontId.val() !== '' && this.colorId.val() !== '' && this.string.val() !== '' && this.quantity.val() !== '') {
            if (this.currentRequest !== null) {
                this.currentRequest.abort();
            }

            this.currentRequest = $.ajax({
                type: "POST",
                url: "/string-traitement",
                data: data,
                beforeSend: function (xhr) {
                    $('#show-result').removeClass('hide');
                },
                success: function (data2) {
                    let dt = new Date();
                    let date = dt.getDate() + "" + dt.getMonth() + "" + dt.getYear() + "" + dt.getHours() + "" + dt.getMinutes() + "" + dt.getSeconds() + "" + dt.getMilliseconds();
                    let stencil = document.getElementById("stencil_letter");

                    $('#cart-btn, #cart-btn-2').removeClass('hide');
                    $('#price_line').removeClass('hide');
                    $('.text-price').html(data2['amount']);
                    $('#text-width').html(data2['dimensions']['width']);

                    $('#generatedSvg').val(data2['generated_svg']);

                    let previewRatio;

                    if (data2['desired_width']) {
                        if (parseFloat(self.desiredWidth.val()) !== data2['desired_width']) {
                            self.desiredWidth.val(data2['desired_width']);
                        }

                        previewRatio = data2['desired_width'] / data2['dimensions']['width'];
                    } else {
                        if (parseFloat(self.desiredWidth.val()) !== data2['dimensions']['width']) {
                            self.desiredWidth.val(data2['dimensions']['width']);
                        }

                        previewRatio = 1;
                    }

                    self.desiredWidthResume.html(self.desiredWidth.val());

                    if (data2['ratio']) {
                        $('#text-ratio').html(data2['ratio']);
                        self.globalMinWidth = Math.round(self.globalMinHeight * 10 / data2['ratio']) / 10;
                        self.globalMaxWidth = Math.round(self.globalMaxHeight * 10 / data2['ratio']) / 10;

                        self.desiredWidth
                            .attr("min", self.globalMinWidth)
                            .attr("max", self.globalMaxWidth);

                        if (parseFloat(self.desiredWidth.val()) < self.globalMinWidth) {
                            self.desiredWidth.val(self.globalMinWidth);
                        }
                    }

                    if (data2['proportion'] && data2['dimensions']['full_height']) {
                        $('#text-height').html(data2['dimensions']['full_height']);

                        if (parseFloat(self.desiredWidth.val()) !== data2['dimensions']['full_height']) {
                            self.desiredHeight.val(data2['dimensions']['full_height']);
                        }
                    }

                    if (data2['dimensions']['height'] === false) {
                        $('#line-height-container').addClass('hide');
                    } else {
                        $('#line-height-container').removeClass('hide');
                        $('#line-height').html(data2['height']);
                        $('#line-real-height').html(data2['dimensions']['formatted_height']);
                        $('.line-height').html(data2['height']);
                        $('.line-real-height').html(data2['dimensions']['formatted_height']);
                        $('.uniq-line-height').html(data2['uniq_line_height']);
                    }

                    if (1 < data2['lines_count']) {
                        $('.uniq-line-height-container').removeClass('hide');
                    } else {
                        $('.uniq-line-height-container').addClass('hide');
                    }

                    if (self.strictHeight.is(':checked')) {
                        $('.line-real-height-container').removeClass('hide');
                        // $('.desired-height-type').html('Corps')
                    } else {
                        $('.line-real-height-container').addClass('hide');
                        // $('.desired-height-type').html('Hauteur')
                    }

                    if (!document.body.contains(stencil)) {
                        // on autorise une hauteur supérieure à 58 pour les textes multi-lignes
                        // voir également dans setLimitHeight()
                        self.desiredHeight.attr("max", self.getCurrentMaxHeight());
                    }

                    if (!self.notChangeImage) {
                        if (data2['svg'] !== false) {
                            self.containerPreview.html(data2['svg']);

                            if (~data2['svg'].indexOf('svg')) {
                                const marge = 3;
                                let largeur = (document.getElementById("texte_svg").getBBox().width);
                                let hauteur = (document.getElementById("texte_svg").getBBox().height);
                                let line_height = data2['height'];
                                let marge_stencil = (line_height * 0.0517) * 2;
                                let marge_stencil_to_pixel = 37.8 * marge_stencil;
                                let ratio = 1;

                                if (marge_stencil < 1) {
                                    marge_stencil_to_pixel = 37.8 * 2;
                                }

                                let svg = $('#image-preview')[0];
                                svg.setAttribute('viewBox', '0 0 ' + largeur + ' ' + hauteur);

                                if (data2.lines_count >= 3) {
                                    ratio = data2.lines_count * ((1 / data2.lines_count) + 0.12);
                                }

                                let viewHeight = (hauteur + marge) / ratio;
                                if (viewHeight > hauteur) {
                                    viewHeight = hauteur;
                                }
                                let viewWidth = largeur / ratio;
                                if (viewWidth < largeur && !document.body.contains(stencil)) {
                                    largeur = viewWidth;
                                }
                                if (document.body.contains(stencil)) {
                                    largeur = (largeur + marge_stencil_to_pixel);
                                    viewHeight = hauteur;
                                }

                                svg.setAttribute('height', viewHeight);

                                if (data2['proportion'] === false) {
                                    svg.setAttribute('preserveAspectRatio', 'none');
                                    svg.setAttribute('width', (largeur * previewRatio));
                                } else {
                                    svg.setAttribute('width', largeur + marge);
                                }
                            }
                        } else {
                            self.containerPreview.html('<img src="/img/buffer.png" alt="Lettres Adhésives" id="image-preview">');
                            $('#image-preview').attr('src', '/preview/' + date);
                        }
                    } else {
                        self.loading.hide();
                    }

                    $(window).trigger('resize');

                    setTimeout(function () {
                        // remove max-height
                        $('.la-letter-preview-container').css('max-height', 'none');
                    }, 3000);

                    // Save data in local storage all to reload if page changed
                    localStorage.setItem('letterData', JSON.stringify(data));

                },
                error: function (xhr, status) {
                    if (status === 'abort') {
                        return;
                    }

                    let response = JSON.parse(xhr.responseText);
                    self.containerPreview.html(response.error);
                }
            });
        } else if (this.string.val() === '') {
            this.containerPreview.html('<img src="/img/buffer.png" alt="Lettres Adhésives" id="image-preview">');

            $('#cart-btn, #cart-btn-2').addClass('hide');
            $('#price_line').addClass('hide');
            $('#text-height').html(0);
            $('.text-price').html(0);
            $('#text-width').html(0);

            this.desiredWidth.val(this.globalMinWidth);
            this.desiredHeight.val(this.globalMinHeight);

            $('#line-height-container').addClass('hide');
        }
    }

    init() {
        this.string.attr("disabled", false);
        if (this.string.val() === '') {
            this.loading.hide();
        }
        if (this.colorId.val() !== '') {

            $('#color-selector [data-id="color-' + this.colorId.val() + '"]')
                .find('span.label').removeClass('hide');
        }
        if (this.colorBgId.val() !== '') {

            $('#surface-selector [data-id="color-' + this.colorBgId.val() + '"]')
                .find('span.label').removeClass('hide');
        }
        if (this.fontId.val() !== '') {

            $('#font-' + this.fontId.val())
                .find('span.label').removeClass('hide');
        }
        if (this.sizeId.val() !== '') {

            $('#size-' + this.sizeId.val())
                .find('span.label').removeClass('hide');
        }
        let self = this;

        this.string.on("click", function () {
            if (self.string.hasClass('first-load')) {
                self.string.removeClass('first-load');

                if (self.string.val() === DEFAULT_TEXT) {
                    self.string.val('');
                }

                clearInterval();

                let $stringContainer = $(".string-container");

                if ($stringContainer.hasClass("string-bg")) {
                    $stringContainer.removeClass("string-bg");
                }
            }
        });

        let $spacingContainer = $('#spacing-container');

        if (this.spacing.val() === '') {

            this.spacing.val(0);
            $spacingContainer.html(0);
        } else {
            let arraySpacing = this.valuesArraySpacing[Letter.findInArray(this.valuesArraySpacing, 0)];
            $spacingContainer.html((typeof arraySpacing !== 'undefined' ? arraySpacing[1] : 0));
        }
        if (this.containerPreview.overflown()) {

            this.leftClick.show();
            this.rightClick.show();
        } else {
            this.leftClick.hide();
            this.rightClick.hide();
        }
        if (this.letter || this.string.val() !== '') {

            this.displayPreview(true);
        }

        // si rien sélectionné : on sélectionne le premier
        let $fontSelector = $("#font-selector"),
            $colorSelector = $("#color-selector"),
            $bgColorSelector = $("#surface-selector");

        $('.js-la-letter-textarea .select2-color').select2({
            dropdownPosition: 'below',
            minimumResultsForSearch: Infinity,
            width: 'auto',
            dropdownAutoWidth : true,
            templateResult: function (state) {
                var color = $(state.element).attr('data-color');
                var $state = $(
                    '<span class="d-flex align-items-center la-letter-textarea-color-suggestion"><span style="margin-right: 10px; display: inline-block; background-color: #' + color + '; width: 24px; height: 24px; border-radius: 400px"></span> ' + state.text + '</span>'
                );
                return $state;
            },
            templateSelection: function (state) {
                var color = $(state.element).attr('data-color');
                var $state = $(
                    '<span class="d-flex align-items-center overflow-hidden"><span style="margin-right: 10px; display: inline-block; background-color: #' + color + '; width: 24px; height: 24px; border-radius: 400px"></span> ' + state.text + '</span>'
                );
                return $state;
            }
        });

        this.attachEvents();

        $('#info_personnalisation_text').slideUp(300);

        let selectedFont = $fontSelector.find('.selected');
        if (selectedFont.length > 0) {
            self.selectFont(selectedFont[0]);
        } else {
            $fontSelector.find(".font-select").first().trigger('click');
        }

        if (!self.editMode && $colorSelector.find(':selected').length > 0) {
            self.selectColorV2($colorSelector.find(':selected').data());
        }

        if ($colorSelector.find(':selected').length > 0) {
            self.selectColorV2($colorSelector.find(':selected').data());
        }

        if ($bgColorSelector.find(':selected').length > 0) {
            self.selectColorV2($colorSelector.find(':selected').data());
        }

        // if (!self.editMode && $colorSelector.find('.default').length > 0) {
        //     self.selectColor($colorSelector.find(".default")[0]);
        // }
        //
        // if ($colorSelector.find('.selected').length > 0) {
        //     self.selectColor($colorSelector.find(".selected")[0]);
        // }
        //
        // if ($bgColorSelector.find('.selected').length > 0) {
        //     self.selectColor($bgColorSelector.find(".selected")[0]);
        // }

        if (self.editMode === '0' && localStorage.getItem('letterData') && window.location.search.includes('from-perso')) {
            const savedData = JSON.parse(localStorage.getItem('letterData'));
            Object.keys(savedData).forEach(key => {
                const element = this[_.camelCase(key)];
                if (key === 'strict_height') {
                    element.prop('checked', savedData[key] !== 1);
                } else if (key === 'mirror') {
                    console.log(key, element, savedData[key])
                    element.prop('checked', savedData[key] === '1');
                    if (savedData[key] === '1') {
                        $('a[data-radio-toggle="input.mirror"]').addClass('active');
                    } else {
                        $('a[data-radio-toggle="input.mirror"]').removeClass('active');
                    }
                } else if (element && element.is(':checkbox')) {
                    console.log(key, element, savedData[key])
                    element.prop('checked', savedData[key] === 1);
                } else if (element && element.is(':radio')) {
                    console.log(key, element, savedData[key])
                    element.prop('checked', savedData[key] === 1);
                } else if (element && element.val) {
                    element.val(savedData[key]);
                    // element.trigger('change.select2');
                    if (key === 'font_id') {
                        $('#font-' + savedData[key]).addClass('selected');
                        $('.js-font-name').html($('#font-' + savedData[key]).data('name'))
                    }
                    if (key === 'color_id') {
                        $('#color-selector option[value=' + savedData[key] + ']').prop('selected', true);
                        $('#color-selector').val(savedData[key]).trigger('change')
                        // element.select2(savedData[key], null, false);
                        element.trigger('change.select2');
                    }
                } else if (element && element.is) {
                    element.prop('checked', savedData[key] === 1);
                }
            });
            self.selectColorV2($colorSelector.find(':selected').data());
            this.displayPreview(true);
        }
    }

    attachEvents() {
        let self = this;

        $(document)
            .ajaxStart(function () {
                self.loading.show();
            })
            .ajaxStop(function () {
                self.loading.hide();
            });

        $('#image-preview').on('load', function () {
            self.loading.hide();

            if (self.containerPreview.overflown()) {
                self.leftClick.show();
                self.rightClick.show();
            } else {
                self.leftClick.hide();
                self.rightClick.hide();
            }
        });

        $('.font-select').on('click', function (event) {
            self.selectFont($(this));
        });

        $('.js-la-letter-textarea .select2-color').on('select2:select', function (e) {
            var data = e.params.data;
            console.log($(data.element).data())
            self.selectColorV2($(data.element).data());
        });

        $('.color-select').on('click', function (event) {
            self.selectColor($(this));
        });

        this.alignItems.on('click', function (event) {
            event.preventDefault();

            self.alignItems.removeClass('active');
            $(this).addClass('active');

            self.align.val($(this).data('align'));
            self.displayPreview(true);
        });

        // saisie longueur
        this.desiredWidth.on('keypress', function (e) {
            if (e.which != 8 && e.which != 0 && e.which != 44 && e.which != 46 && (e.which < 48 || e.which > 57)) {
                return false;
            }
        });

        this.desiredWidth.on('keyup change touchend', function (event) {
            event.stopPropagation();
            if (event.keyCode === 9) return; // tab

            self.sizeDelay(function () {
                if (self.setLimitWidth() !== false && self.checkDimensions("width")) {
                    self.notChangeImage = false;
                    self.displayPreview(false);
                }
            }, DEBOUNCE_DURATION);
        });

        // saisie largeur
        this.desiredHeight.on('keypress', function (e) {
            if (e.which != 8 && e.which != 0 && e.which != 44 && e.which != 46 && (e.which < 48 || e.which > 57)) {
                return false;
            }
        });

        this.desiredHeight.on('keyup change touchend', function (e) {
            e.stopPropagation();

            self.sizeDelay(function () {
                if (self.setLimitHeight() !== false && self.checkDimensions("height")) {
                    self.notChangeImage = false;
                    self.displayPreview(1);
                }
            }, DEBOUNCE_DURATION);
        });

        this.proportion.on('change', function (event) {
            event.stopPropagation();

            self.setLimitWidth(true);
            self.setLimitHeight(true);

            if (self.checkDimensions(this.checked ? "height" : "width")) {
                self.notChangeImage = false;
                self.displayPreview(true);
            }
        });

        this.string.on('keyup touchend', $.debounce(500, false, function () {
            const numberOfLineBreaks = (self.string.val().match(/\n/g)||[]).length;
            $('.js-letter-align').parent().addClass('hide');
            if (numberOfLineBreaks >= 1) {
                $('.js-letter-align').parent().removeClass('hide');
            }
            if (self.stringTimeout) {
                clearTimeout(self.stringTimeout);
            }

            self.stringTimeout = setTimeout(function () {
                if (self.checkDimensions("height")) {
                    self.notChangeImage = false;
                    self.displayPreview(true);
                }
            }, 200);
        }));

        this.quantity.on('change keyup', function () {
            self.notChangeImage = true;

            if (self.quantity.val() === 0 && self.quantity.val() !== "") {
                bootbox.alert("Impossible de commander cette quantité", function () {
                });
            } else {
                self.displayPreview();
            }
        });

        this.proportion.change(function () {
            self.notChangeImage = false;
            self.displayPreview(this.checked);
        });

        this.mirror.on('change', function () {
            self.onMirrorChange();
        });

        $(document).on('change', this.strictHeight, function (e) {
            self.notChangeImage = false;
            self.changeTypeHeightText();
            self.displayPreview(true);
        });

        if (this.nomade) {
            let interval;

            this.leftClick
                .mousedown(function () {
                    let theObj = this;

                    interval = setInterval(function () {
                        $(theObj).next().next().scrollLeft($(theObj).next().next().scrollLeft() - 50);
                    }, 50);
                }).mouseup(function () {
                clearInterval(interval);
            }).mouseleave(function () {
                clearInterval(interval);
            });

            this.leftClick.bind("touchstart", function (e) {
                let theObj = this;

                interval = setInterval(function () {
                    $(theObj).next().next().scrollLeft($(theObj).next().next().scrollLeft() - 20);
                }, 50);
            });

            this.leftClick.bind("touchend", function (e) {
                clearInterval(interval);
            });

            this.rightClick
                .mousedown(function () {
                    let theObj = this;

                    interval = setInterval(function () {
                        $(theObj).next().scrollLeft($(theObj).next().scrollLeft() + 50);
                    }, 50);
                }).mouseup(function () {
                clearInterval(interval);
            }).mouseleave(function () {
                clearInterval(interval);
            });

            this.rightClick.bind("touchstart", function (e) {
                let theObj = this;

                interval = setInterval(function () {
                    $(theObj).next().scrollLeft($(theObj).next().scrollLeft() + 20);
                }, 50);
            });

            this.rightClick.bind("touchend", function (e) {
                clearInterval(interval);
            });

            this.upClick
                .mousedown(function () {
                    let theObj = this;

                    interval = setInterval(function () {
                        $(theObj).next().scrollTop($(theObj).next().scrollTop() - 50);
                    }, 50);
                }).mouseup(function () {
                clearInterval(interval);
            }).mouseleave(function () {
                clearInterval(interval);
            });

            this.upClick.bind("touchstart", function (e) {
                let theObj = this;
                interval = setInterval(function () {
                    $(theObj).next().scrollTop($(theObj).next().scrollTop() - 20);
                }, 50);
            });

            this.upClick.bind("touchend", function (e) {
                clearInterval(interval);
            });

            this.downClick
                .mousedown(function () {
                    let theObj = this;

                    interval = setInterval(function () {
                        $(theObj).prev().scrollTop($(theObj).prev().scrollTop() + 50);
                    }, 50);
                })
                .mouseup(function () {
                    clearInterval(interval);
                }).mouseleave(function () {
                clearInterval(interval);
            });

            this.downClick.bind("touchstart", function (e) {
                let theObj = this;

                interval = setInterval(function () {
                    $(theObj).prev().scrollTop($(theObj).prev().scrollTop() + 20);
                }, 50);
            });

            this.downClick.bind("touchend", function (e) {
                clearInterval(interval);
            });
        }

        // Gestion checkboxs options miroir/pochoir
        $('input.oneChoice').change(function () {
            $('input.oneChoice').not(this).prop('checked', false);

            if (self.mirror.is(':checked')) {
                $('#infos-option-pochoir').slideUp(300, function () {
                    $('#infos-option-miroir').slideDown(300);
                });
            } else {
                $('#infos-option-miroir').slideUp(300);
                $('#infos-option-pochoir').slideUp(300);
            }

            self.displayPreview();
        });

        $('#info_personnalisation').click(function () {
            let $info = $('#info_personnalisation_text');

            if ($info.is(':visible')) {
                $info.slideUp(300);
            } else {
                $info.slideDown(300);
            }
        });

        let $specialCharContainer = $('.special_char_container');
        $specialCharContainer.fadeOut(0);

        let focusOutTimeout = null;

        $('#textbox')
            .on('focusin', function () {
                clearTimeout(focusOutTimeout);
                $specialCharContainer.fadeIn(100);
            })
            .on("focusout", function () {
                clearTimeout(focusOutTimeout);
                focusOutTimeout = setTimeout(function () {
                    $specialCharContainer.fadeOut(100);
                }, 200);
            });

        $specialCharContainer.each(function () {
            $(this).find('ul li span').click(function () {
                let html = $(this).html();

                self.string
                    .val(self.string.val() + html)
                    .focus()
                    .trigger('keyup');
            });
        });
    }

    onMirrorChange() {
        let self = this;

        self.notChangeImage = false;
        self.displayPreview();
        if(this.mirror.find(':checked').val()) {
            if ($('#align').val() === 'right') {
                $("button[data-align='left']").click();
            } else {
                $("button[data-align='right']").click();
            }
        }
    }

    /**
     * Legacy method
     *
     * @returns {boolean}
     */
    setLimitHeight() {
        let stencil = document.getElementById("stencil_letter");
        let value = this.desiredHeight.val();
        let maxHeight = this.getCurrentMaxHeight();;

        if (isNaN(value)) {
            return false;
        }

        if (parseFloat(value) < this.globalMinHeight) {
            this.desiredHeight.val(this.globalMinHeight);
        }

        if (document.body.contains(stencil)) {
            maxHeight = this.globalMaxHeight;
        }

        if (parseFloat(value) > maxHeight) {
            this.desiredHeight.val(maxHeight);
        }
    }

    /**
     * Legacy method
     *
     * @returns {boolean}
     */
    setLimitWidth() {
        let value = this.desiredWidth.val();

        if (isNaN(value)) {
            return false;
        }

        if (parseFloat(value) < this.globalMinWidth) {
            this.desiredWidth.val(this.globalMinWidth);
        }

        if (parseFloat(value) > this.globalMaxWidth) {
            this.desiredWidth.val(this.globalMaxWidth);
        }
    }

    /**
     * Legacy method
     *
     * @param changedDim
     *
     * @returns {boolean}
     */
    checkDimensions(changedDim) {
        let ratio = $("#text-ratio").text();

        if (this.proportion.is(":checked")) {
            // proportions gardées : on utilise le ratio
            switch (changedDim) {
                case "height":
                    let newWidth = Math.round(this.desiredHeight.val() / (ratio * 10)) / 10;

                    if (newWidth === 0 || isNaN(newWidth)) return true;

                    if (parseFloat(this.desiredWidth.val()) !== newWidth) {
                        if (newWidth >= this.globalMinWidth) {
                            this.desiredWidth.val(newWidth);
                        }
                        return true;
                    }
                    break;
                case "width":
                    let newHeight = Math.round(this.desiredWidth.val() * (ratio * 10)) / 10;

                    if (newHeight === 0 || isNaN(newHeight)) return true;

                    if (this.globalMaxWidth && newHeight > this.globalMaxHeight) {
                        this.desiredHeight.val(this.globalMaxHeight);
                        this.desiredWidth.val(this.globalMaxWidth);
                    } else if (this.globalMinWidth && newHeight < this.globalMinHeight) {
                        this.desiredHeight.val(this.globalMinHeight);
                        this.desiredWidth.val(this.globalMinWidth);
                    } else {
                        if (parseFloat(this.desiredHeight.val()) !== newHeight) {
                            this.desiredHeight.val(newHeight);
                        }
                    }
                    return true;
                default:
                    break;
            }
        } else {
            // proportion non gardée, on fixe des limites
            switch (changedDim) {
                case "height":
                    return true;
                case "width":
                    let normalHeight = Math.round(this.desiredWidth.val() * ratio * 10) / 10;

                    if (normalHeight < this.globalMinHeight) {
                        this.desiredHeight.val(this.globalMinHeight);
                    }

                    return true;
                default:
                    break;

            }
        }

        return false;
    }

    /**
     * Legacy method
     *
     * @returns {Function}
     */
    sizeDelay(callback, ms) {
        clearTimeout(this.sizeTimer);
        this.sizeTimer = setTimeout(callback, ms);
    }

    /**
     * Legacy method
     *
     * @param {[]} myArray
     * @param {number} id
     *
     * @returns {number}
     */
    static findInArray(myArray, id) {
        for (let i = 0; i < myArray.length; i++) {
            if (myArray[i][0] === id) {
                return i;
            }
        }
    }

    selectFont(obj) {
        let self = this;
        self.checkDimensions("height");
        $('.font-select').removeClass('selected');
        $(obj).addClass('selected');
        self.fontId.val($(obj).attr('id').substring(5));
        self.notChangeImage = false;
        $('.js-font-name').html($(obj).data('name'));
        $('#font-collapseFont').html($(obj).data('name') + '<svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>');
        self.displayPreview(1);
        $('#collapseFont').removeClass('show');

        scrollOnClick($('#font-collapseFont'), $('#collapseFont'));
    }

    selectColor(colorObj) {
        let self = this;
        let type = $(colorObj).data('type');
        let $paletteWrapper = null;
        let $colorCollapsePalette = null;
        let color = "ffffff";
        let $collapsePalette = null;

        let colorHtml = $(colorObj).data('color-html');

        if ('bg' === type) {
            $paletteWrapper = $('#surface-selector');
            $colorCollapsePalette = $('#surface-collapsePalette');
            $collapsePalette = $('#collapsePaletteSurface');

            scrollOnClick($colorCollapsePalette, $collapsePalette)

            self.colorBgId.val($(colorObj).data('id').substring(6));

            if (this.moduleWindow.hasClass('wz-module-changeable-background')) {
                if ('none' === colorHtml) {
                    this.bgColorHtml = colorHtml;
                    this.moduleWindow.css('background', '');

                    if (this.isLightColor(this.colorHtml)) {
                        this.moduleWindow.addClass('wz-module-bg-darker');
                    } else {
                        this.moduleWindow.removeClass('wz-module-bg-darker');
                    }
                } else {
                    this.bgColorHtml = '#' + colorHtml;
                    this.moduleWindow.css('background', '#' + colorHtml);
                }
            }
        } else if ('object' === type) {
            $paletteWrapper = $('#color-selector');
            $colorCollapsePalette = $('#color-collapsePalette');
            $collapsePalette = $('#collapsePalette');

            scrollOnClick($colorCollapsePalette, $collapsePalette)

            self.colorId.val($(colorObj).data('id').substring(6));
            this.colorHtml = '#' + colorHtml;

            if ('none' === this.bgColorHtml && this.isLightColor(this.colorHtml)) {
                this.moduleWindow.addClass('wz-module-bg-darker');
            } else {
                this.moduleWindow.removeClass('wz-module-bg-darker');
            }
        }

        if ($paletteWrapper) {
            $paletteWrapper.find('.color-select').removeClass('selected');
        }
        $(colorObj).addClass('selected');

        if ($paletteWrapper) {
            $paletteWrapper.find('.color-name').text($(colorObj).find('.color-display').data('color'));
        }
        self.notChangeImage = false;
        self.displayPreview(1);

        if ($colorCollapsePalette) {
            $colorCollapsePalette.siblings('.module-label').html($(colorObj).data('color'));

            $colorCollapsePalette
                .css('background-color', '#' + colorHtml)
                .css('background-image', 'initial')
                .css('color', '#' + color);

            $collapsePalette.removeClass('show');
        }
    }

    selectColorV2(data) {
        let self = this;
        let type = 'object';
        let $paletteWrapper = null;
        let $colorCollapsePalette = null;
        let color = "ffffff";
        let $collapsePalette = null;

        let colorHtml = data.color;

        if ('bg' === type) {
            $paletteWrapper = $('#surface-selector');
            $colorCollapsePalette = $('#surface-collapsePalette');
            $collapsePalette = $('#collapsePaletteSurface');

            scrollOnClick($colorCollapsePalette, $collapsePalette)

            self.colorBgId.val(data.value);

            if (this.moduleWindow.hasClass('wz-module-changeable-background')) {
                if ('none' === colorHtml) {
                    this.bgColorHtml = colorHtml;
                    this.moduleWindow.css('background', '');

                    if (this.isLightColor(this.colorHtml)) {
                        this.moduleWindow.addClass('wz-module-bg-darker');
                    } else {
                        this.moduleWindow.removeClass('wz-module-bg-darker');
                    }
                } else {
                    this.bgColorHtml = '#' + colorHtml;
                    this.moduleWindow.css('background', '#' + colorHtml);
                }
            }
        } else if ('object' === type) {
            $paletteWrapper = $('#color-selector');
            $colorCollapsePalette = $('#color-collapsePalette');
            $collapsePalette = $('#collapsePalette');

            scrollOnClick($colorCollapsePalette, $collapsePalette)

            self.colorId.val(data.value);
            this.colorHtml = '#' + colorHtml;
            if ('none' === this.bgColorHtml && this.isLightColor(this.colorHtml)) {
                this.moduleWindow.addClass('wz-module-bg-darker');
            } else {
                this.moduleWindow.removeClass('wz-module-bg-darker');
            }
        }

        if ($paletteWrapper) {
            $paletteWrapper.find('.color-select').removeClass('selected');
        }

        // if ($paletteWrapper) {
        //     $paletteWrapper.find('.color-name').text($(colorObj).find('.color-display').data('color'));
        // }
        self.notChangeImage = false;
        self.displayPreview(1);

        if ($colorCollapsePalette) {
            $colorCollapsePalette.siblings('.module-label').html(data.color);

            $colorCollapsePalette
                .css('background-color', '#' + colorHtml)
                .css('background-image', 'initial')
                .css('color', '#' + color);

            $collapsePalette.removeClass('show');
        }
    }

    isWhiteColor(color) {
        // checks whether a color is white
        return color.match(/^(?:white|#fff(?:fff)?|rgba?\(\s*255\s*,\s*255\s*,\s*255\s*(?:,\s*1\s*)?\))$/i);
    }

    /**
     * Using the HSP value, determine whether the color is light or dark
     *
     * @param color
     * @returns {boolean}
     */
    isLightColor(color) {
        if ('red' === window.letter_theme) {
            return this.isWhiteColor(color);
        }

        let r, g, b, hsp;

        if (color.match(/^rgb/)) {

            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

            r = color[1];
            g = color[2];
            b = color[3];
        } else {

            color = +("0x" + color.slice(1).replace(
                color.length < 5 && /./g, '$&$&'));

            r = color >> 16;
            g = color >> 8 & 255;
            b = color & 255;
        }

        hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
        );

        return hsp > 180;
    }


    changeTypeHeightText() {
        const isStrictHeight = this.strictHeight.is(':checked') ? 0 : 1;

        if (isStrictHeight) {
            this.strictHeightTextSelector.text(STRICT_HEIGHT_TEXT)
        } else {
            this.strictHeightTextSelector.text(BODY_FONT_HEIGHT_TEXT)
        }
    }


    getLineCount() {
        return this.string.val().trim().split("\n").length
    }

    // retourne la hauteur maximum (en cm) en fonction du texte actuel
    // note : le seuil MULTIROLL_THRESHOLD_LINES n'est pas implémenté coté serveur actuellement
    getCurrentMaxHeight() {
        if (this.getLineCount() < MULTIROLL_THRESHOLD_LINES) {
            return this.globalMaxHeight;
        } else {
            return this.globalMaxHeight * this.getLineCount();
        }
    }

    /**
     * @returns {*[]}
     */
    static getDefaultValuesArraySpacing() {
        return [
            ['-10', '-10'],
            ['-9', '-9'],
            ['-8', '-8'],
            ['-7', '-7'],
            ['-6', '-6'],
            ['-5', '-5'],
            ['-4', '-4'],
            ['-3', '-3'],
            ['-2', '-2'],
            ['-1', '-1'],
            ['0', '0'],
            ['7', '1'],
            ['8', '2'],
            ['9', '3'],
            ['10', '4'],
            ['11', '5'],
            ['12', '6'],
            ['13', '7'],
            ['14', '8'],
            ['15', '9'],
            ['16', '10']
        ];
    };
}
